/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Credentials_UnsupportedInputs */



/**
* | output |
* | --- |
* | "This connector can't be reconnected yet." |
*
* @param {Spaces_Credentials_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_credentials_unsupported = /** @type {((inputs?: Spaces_Credentials_UnsupportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Credentials_UnsupportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Connector kann noch nicht neu verbunden werden.")
	return /** @type {LocalizedString} */ ("This connector can't be reconnected yet.")
});